import React from "react";
import StyledTableContainer from "../../../newTestPrep/newComponent/TableContainer";
import {
  Box,
  Chip,
  Grid,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { fDate } from "../../../utils/formatTime";

export default function ProductDetailsData({ data, year }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="center">
          <Typography variant="h4">
            {data?.name} ({year})
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <StyledTableContainer component={Paper}>
            <Table aria-label="simple table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Month</TableCell>
                  <TableCell>Currency</TableCell>
                  <TableCell>Target</TableCell>
                  <TableCell>Achieved</TableCell>
                  <TableCell>Percentage</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.month_val?.length === 0 ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h5">No data available</Typography>
                  </Grid>
                ) : (
                  data?.month_val?.map((row, index) => {
                    const progress = (row.achieved / row.target) * 100;

                    return (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f0f0f0" : "inherit",
                          width: "6%",
                        }}
                      >
                        <TableCell>{row?.month}</TableCell>
                         <TableCell>{row?.currency}</TableCell>
                        <TableCell>{row?.target}</TableCell>
                        <TableCell>{row?.achieved}</TableCell>
                        <TableCell>
                          {row?.target === 0 ? (
                            <Chip
                              size="normal"
                              variant="contained"
                              color="primary"
                              label="No Revenue Target Available"
                            />
                          ) : (
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={1}
                              width="100%"
                              justifyContent="center"
                            >
                              <Tooltip title={row?.achieved} arrow>
                                <LinearProgress
                                  variant="determinate"
                                  value={progress}
                                  sx={{
                                    width: "120px",
                                    height: 5,
                                    borderRadius: 5,
                                    cursor: "pointer",
                                    justifyContent: "center",
                                  }}
                                />
                              </Tooltip>
                              <Typography variant="h7" sx={{ minWidth: 40 }}>
                                {Math.round(progress)}%
                              </Typography>
                            </Box>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      </Grid>
    </>
  );
}
